// 栄養カウンセリング報告書の欄: キー → 見出しの単一定義。
// 並びは back の REPORT_KEYS (nutrition_counseling/fields.py) と同じにし、
// キーの一覧は reportFields.test.ts で固定する (欄の増減は back と同時に直す)。
// 3 種の様式 (医療機関 / 薬局 / カフェ) の欄の和集合で、様式ごとの出し分けは Excel 出力側が持つ。
// 画面の配置は NutritionReportPanel が様式の番地で持つので、ここは見出しの辞書だけ。

export interface ReportField {
  key: string
  label: string
}

export const REPORT_FIELDS: ReportField[] = [
  // 患者と依頼
  { key: 'name_kana', label: 'ふりがな' },
  { key: 'name', label: '氏名' },
  { key: 'sex', label: '性別' },
  { key: 'birthday', label: '生年月日' },
  { key: 'counseled_person', label: '指導を受けた人' },
  { key: 'session_number', label: '指導回数' },
  { key: 'institution', label: '医療機関名' },
  { key: 'physician', label: '医師名' },
  { key: 'instruction', label: '指示内容' },
  { key: 'instructed_energy', label: '指示エネルギー (kcal)' },
  { key: 'instructed_nutrition_other', label: '指示栄養量 (その他)' },
  { key: 'consultation', label: '相談内容' },
  { key: 'referring_store', label: '依頼店舗' },
  { key: 'referring_pharmacist', label: '依頼薬剤師' },
  // S
  { key: 'subjective', label: '本人の訴え' },
  // O
  { key: 'height', label: '身長 (cm)' },
  { key: 'weight', label: '体重 (kg)' },
  // 体型判定は数式 (BMI の区分) でなく欄。体組成計の表から人が選ぶ (design-book ADR-0077・0079)
  { key: 'body_type', label: '体型判定' },
  { key: 'lab_values', label: '検査値' },
  { key: 'medication', label: '服薬状況' },
  { key: 'wake_up', label: '起床' },
  { key: 'breakfast', label: '朝食' },
  { key: 'lunch', label: '昼食' },
  { key: 'snack', label: '間食' },
  { key: 'dinner', label: '夕食' },
  { key: 'bedtime', label: '就床' },
  { key: 'beverages', label: '飲料' },
  { key: 'alcohol', label: '飲酒' },
  { key: 'exercise', label: '運動' },
  // A
  { key: 'assessment', label: '栄養面の課題' },
  // P
  { key: 'short_term_goals', label: '短期目標' },
  { key: 'long_term_goal', label: '長期目標' },
  { key: 'target_nutrition', label: '目標栄養量' },
  { key: 'handouts', label: '配布資料' },
  // その他
  { key: 'notes', label: '備考' },
  { key: 'continuation', label: '継続の有無' },
  { key: 'next_date', label: '次回予定日' },
  // 様式の右半分 (自由記載)。会話の要約を LLM が書き、管理栄養士が直す。会話の全文は回の 会話 のタブに読むだけ
  { key: 'summary', label: '要約' },
]

export const REPORT_KEYS: string[] = REPORT_FIELDS.map((f) => f.key)

export const LABEL_BY_KEY: Record<string, string> = Object.fromEntries(
  REPORT_FIELDS.map((f) => [f.key, f.label])
)
